import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

const DmarcMadeEasy = () => {
    const {t} = useTranslation();
    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                    {/* Title */}
                    <h1 className="mb-4">{t("posts.dmarcMadeEasy.title")}</h1>

                    {/* Introduction */}
                    <p>
                        {t("posts.dmarcMadeEasy.sections.introduction")}
                    </p>

                    {/* Section 1: What is DMARC? */}
                    <h2 className="mt-5">{t("posts.dmarcMadeEasy.sections.whatIsDmarc.title")}</h2>
                    <p dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.whatIsDmarc.descriptions.1")}}>
                    </p>
                    <ul>
                        <li>{t("posts.dmarcMadeEasy.sections.whatIsDmarc.descriptions.2.1")}</li>
                        <li>{t("posts.dmarcMadeEasy.sections.whatIsDmarc.descriptions.2.2")}</li>
                        <li>{t("posts.dmarcMadeEasy.sections.whatIsDmarc.descriptions.2.3")}</li>
                    </ul>

                    {/* Section 2: Why You Need It */}
                    <h2 className="mt-5">{t("posts.dmarcMadeEasy.sections.whyYouNeedIt.title")}</h2>
                    <p>{t("posts.dmarcMadeEasy.sections.whyYouNeedIt.descriptions.1")}</p>
                    <ul>
                        <li>{t("posts.dmarcMadeEasy.sections.whyYouNeedIt.descriptions.2.1")}</li>
                        <li>{t("posts.dmarcMadeEasy.sections.whyYouNeedIt.descriptions.2.2")}</li>
                        <li>{t("posts.dmarcMadeEasy.sections.whyYouNeedIt.descriptions.2.3")}</li>
                    </ul>

                    {/* Section 3: Steps to Implement DMARC */}
                    <h2 className="mt-5">{t("posts.dmarcMadeEasy.sections.stepsToReproduce.title")}</h2>
                    <p>{t("posts.dmarcMadeEasy.sections.stepsToReproduce.decriptions.1")}</p>
                    <ol>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.stepsToReproduce.descriptions.2.1")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.stepsToReproduce.descriptions.2.2")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.stepsToReproduce.descriptions.2.3")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.stepsToReproduce.descriptions.2.4")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.stepsToReproduce.descriptions.2.5")}}></li>
                    </ol>

                    {/* Section 4: Common Pitfalls */}
                    <h2 className="mt-5">{t("posts.dmarcMadeEasy.sections.commonPitfalls.title")}</h2>
                    <p>
                        {t("posts.dmarcMadeEasy.sections.commonPitfalls.descriptions.1")}
                    </p>
                    <ul>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.commonPitfalls.descriptions.2.1")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.commonPitfalls.descriptions.2.2")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.commonPitfalls.descriptions.2.3")}}></li>
                    </ul>

                    {/* Conclusion */}
                    <p className="mt-5"
                       dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.conclusion.1")}}>
                    </p>
                    <p dangerouslySetInnerHTML={{__html: t("posts.dmarcMadeEasy.sections.conclusion.2")}}>
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default DmarcMadeEasy;
